import {Box, Button, List, ListItem, ListItemButton, ListItemIcon, Typography} from "@mui/material";
import {setMenuItem} from "../../../../../app/slices/drawer";
import IconUI from "../../../../ui/icon";
import {CustomTooltip} from "../../../../ui";
import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useMenu} from "../../../../../shared/hooks/useMenu";


export const QrBlock = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation()
  const user = useSelector((state: any) => state.dashboard.user);
  const company = useSelector((state: any) => state.dashboard.company);

  const { open, menu, openMenuHandler, closeMenuHandler } = useMenu('isQrMenuOpen');

  return (
      <CustomTooltip
          open={menu || open}
          onClose={closeMenuHandler}
          title={
            <Box sx={{position: 'relative', transform: "translate(-40px, 52px)"}}>
              <Box sx={{
                width: "24px",
                height: "13px",
                backgroundColor: "#ffffff",
                clipPath: "polygon(0 0, 24px 0, 12px 12px)",
                transform: "rotate(180deg)",
                position: 'absolute',
                right: "44px",
                top: "-12px"
              }}>

              </Box>
              <Box sx={{
                boxShadow: "0px 0px 16px 0px #E5E5E5",
                backgroundColor: '#FFFFFF',
                borderRadius: "10px",
                width: '227px',
                color: "#2D2D2D",
                padding: "0",
              }}>
                <List>
                  <ListItem disablePadding>
                    <ListItemButton
                        disabled={company?.kyb_status !== 'approved'}
                        disableRipple
                        sx={{
                          textDecoration: 'none',
                          padding: "8px 16px",
                          display: 'flex',
                          alignItems: 'center',
                          gap: "16px"
                        }}
                        onClick={()=>{
                          window.location.replace('/home/top-up')
                          dispatch(setMenuItem('/top-up'))
                          closeMenuHandler()
                        }}
                    >
                      <ListItemIcon sx={{minWidth: "24px"}}>
                        <IconUI name="topup"/>
                      </ListItemIcon>
                      <Typography variant="subtitle1" sx={{fontWeight: 500, color: "#2D2D2D"}}>
                        {`Top Up ${t("qr_balance")}`}
                      </Typography>
                    </ListItemButton>

                  </ListItem>
                </List>
              </Box>
            </Box>
          }
      >
        <Button
            onClick={openMenuHandler}
            disableRipple
            sx={{textTransform: 'none'}}
        >

          <Box sx={{display: 'flex', alignItems: 'center', gap: "16px", width: '100%'}}>
            <Box sx={{flexGrow: 1}}>
              <Typography variant="subtitle1" sx={{
                fontWeight: 500,
                textAlign: 'right',
                color: "#2D2D2D"
              }}>{user.qr_balance}</Typography>
              <Typography variant="subtitle2"
                          sx={{textAlign: 'right', color: "#5F5F5F"}}>{t("qr_balance")}</Typography>
            </Box>
            <Box sx={{
              backgroundColor: '#000',
              borderRadius: '50px',
              padding: "12px",
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <IconUI name="qrcode"/>
            </Box>
            <Box sx={menu ? {transform: 'rotate(180deg)'} : {transform: 'rotate(0deg)'}}>
              <IconUI name="icon-down" size={8}/>
            </Box>

          </Box>
        </Button>

      </CustomTooltip>
  )
}